export const calendarList = [
  {
    'id': 5188,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-27',
    'type': 'Custom Holiday',
    'name': '5月节日1',
    'remark': ''
  },
  {
    'id': 5187,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-26',
    'type': 'Custom Holiday',
    'name': '5月节日1',
    'remark': ''
  },
  {
    'id': 5186,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-25',
    'type': 'Custom Holiday',
    'name': '5月节日1',
    'remark': ''
  },
  {
    'id': 5185,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-24',
    'type': 'Custom Holiday',
    'name': '5月节日1',
    'remark': ''
  },
  {
    'id': 5184,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-23',
    'type': 'Custom Holiday',
    'name': '5月节日1',
    'remark': ''
  },
  {
    'id': 5177,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-26',
    'type': 'Custom Holiday',
    'name': '5月节日',
    'remark': ''
  },
  {
    'id': 5176,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-25',
    'type': 'Custom Holiday',
    'name': '5月节日',
    'remark': ''
  },
  {
    'id': 5175,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-23',
    'type': 'Custom Holiday',
    'name': '5月节日',
    'remark': ''
  },
  {
    'id': 5174,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-04',
    'type': 'Custom Holiday',
    'name': '7月节日',
    'remark': ''
  },
  {
    'id': 5173,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-03',
    'type': 'Custom Holiday',
    'name': '7月节日',
    'remark': ''
  },
  {
    'id': 5172,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-05',
    'type': 'Custom Holiday',
    'name': '7月节日',
    'remark': ''
  },
  {
    'id': 5171,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-02',
    'type': 'Custom Holiday',
    'name': '7月节日',
    'remark': '7月节日2号'
  },
  {
    'id': 5170,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-01',
    'type': 'Custom Holiday',
    'name': '7月节日',
    'remark': ''
  },
  {
    'id': 5169,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-24',
    'type': 'Custom Holiday',
    'name': '6月节日',
    'remark': '6月节日'
  },
  {
    'id': 5168,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-29',
    'type': 'Custom Holiday',
    'name': '6月节日',
    'remark': '6月节日'
  },
  {
    'id': 5167,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-22',
    'type': 'Custom Holiday',
    'name': '6月节日',
    'remark': '6月节日'
  },
  {
    'id': 5166,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-31',
    'type': 'Custom Holiday',
    'name': '5月节日',
    'remark': ''
  },
  {
    'id': 5164,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-30',
    'type': 'Custom Holiday',
    'name': '5月节日',
    'remark': ''
  },
  {
    'id': 5163,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-24',
    'type': 'Custom Holiday',
    'name': '5月节日',
    'remark': '5月节日'
  },
  {
    'id': 5162,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-29',
    'type': 'Custom Holiday',
    'name': '5月节日',
    'remark': '5月节日'
  },
  {
    'id': 5161,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-22',
    'type': 'Custom Holiday',
    'name': '5月节日',
    'remark': '5月节日'
  },
  {
    'id': 5160,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-22',
    'type': 'Custom Holiday',
    'name': '522情人节',
    'remark': '522情人节'
  },
  {
    'id': 5159,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-05',
    'type': 'Custom Holiday',
    'name': '5.0',
    'remark': ''
  },
  {
    'id': 5158,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-21',
    'type': 'Custom Holiday',
    'name': '521情人节',
    'remark': '521情人节'
  },
  {
    'id': 5157,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-29',
    'type': 'Custom Holiday',
    'name': 'test2',
    'remark': 'test'
  },
  {
    'id': 5155,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-14',
    'type': 'Custom Holiday',
    'name': '教师节',
    'remark': '教师节'
  },
  {
    'id': 5154,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-13',
    'type': 'Custom Holiday',
    'name': '教师节',
    'remark': '教师节'
  },
  {
    'id': 5153,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-12',
    'type': 'Custom Holiday',
    'name': '教师节',
    'remark': '教师节'
  },
  {
    'id': 5152,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-11',
    'type': 'Custom Holiday',
    'name': '教师节',
    'remark': '教师节'
  },
  {
    'id': 5151,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-10',
    'type': 'Custom Holiday',
    'name': '教师节',
    'remark': '教师节'
  },
  {
    'id': 5150,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-01',
    'type': 'Custom Holiday',
    'name': '五一节日1号',
    'remark': ''
  },
  {
    'id': 5142,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-06',
    'type': 'Custom Holiday',
    'name': '国庆节',
    'remark': '国庆节'
  },
  {
    'id': 5140,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-01',
    'type': 'Custom Holiday',
    'name': '12',
    'remark': ''
  },
  {
    'id': 5137,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-18',
    'type': 'Custom Holiday',
    'name': '五一',
    'remark': '五一'
  },
  {
    'id': 5133,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-02',
    'type': 'Custom Holiday',
    'name': '国庆节',
    'remark': '国庆节'
  },
  {
    'id': 5132,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-01',
    'type': 'Custom Holiday',
    'name': '国庆节',
    'remark': '国庆节'
  },
  {
    'id': 5131,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-10',
    'type': 'Custom Holiday',
    'name': '国庆节',
    'remark': '国庆节'
  },
  {
    'id': 5122,
    'country': 'China',
    'year': '2024',
    'date': '2024-03-15',
    'type': 'Custom Holiday',
    'name': '自定义节日',
    'remark': ''
  },
  {
    'id': 3291,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-31',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3290,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-30',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3289,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-29',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3288,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-28',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3287,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-27',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3286,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-26',
    'type': 'Statutory Holiday',
    'name': 'Christmas Holiday',
    'remark': ''
  },
  {
    'id': 3285,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-25',
    'type': 'Statutory Holiday',
    'name': 'Christmas Day',
    'remark': ''
  },
  {
    'id': 3284,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-24',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3283,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-23',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3282,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-22',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3281,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-21',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3280,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-20',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3279,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-19',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3278,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-18',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3277,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-17',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3276,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-16',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3275,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-15',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3274,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-14',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3273,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-13',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3272,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-12',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3271,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-11',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3270,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-10',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3269,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-09',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3268,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-08',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3267,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-07',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3266,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-06',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3265,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-05',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3264,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-04',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3263,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-03',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3262,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-02',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3261,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-12-01',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3260,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-30',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3259,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-29',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3258,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-28',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3257,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-27',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3256,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-26',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3255,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-25',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3254,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-24',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3253,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-23',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3252,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-22',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3251,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-21',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3250,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-20',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3249,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-19',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3248,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-18',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3247,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-17',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3246,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-16',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3245,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-15',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3244,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-14',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3243,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-13',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3242,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-12',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3241,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-11',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3240,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-10',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3239,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-09',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3238,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-08',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3237,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-07',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3236,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-06',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3235,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-05',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3234,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-04',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3233,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-03',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3232,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-02',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3231,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-11-01',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3230,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-31',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3229,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-30',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3228,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-29',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3227,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-28',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3226,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-27',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3225,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-26',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3224,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-25',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3223,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-24',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3222,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-23',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3221,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-22',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3220,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-21',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3219,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-20',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3218,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-19',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3217,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-18',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3216,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-17',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3215,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-16',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3214,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-15',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3213,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-14',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3212,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-13',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3211,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-12',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3210,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-11',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3209,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-10',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3208,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-09',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3207,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-08',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3206,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-07',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3205,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-06',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3204,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-05',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3203,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-04',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3202,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-03',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3201,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-02',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3200,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-10-01',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3199,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-30',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3198,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-29',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3197,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-28',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3196,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-27',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3195,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-26',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3194,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-25',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3193,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-24',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3192,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-23',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3191,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-22',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3190,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-21',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3189,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-20',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3188,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-19',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3187,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-18',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3186,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-17',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3185,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-16',
    'type': 'Statutory Holiday',
    'name': 'Maulidur Rasul',
    'remark': ''
  },
  {
    'id': 3184,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-15',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3183,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-14',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3182,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-13',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3181,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-12',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3180,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-11',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3179,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-10',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3178,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-09',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3177,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-08',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3176,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-07',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3175,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-06',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3174,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-05',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3173,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-04',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3172,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-03',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3171,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-02',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3170,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-09-01',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3169,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-31',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3168,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-30',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3167,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-29',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3166,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-28',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3165,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-27',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3164,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-26',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3163,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-25',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3162,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-24',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3161,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-23',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3160,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-22',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3159,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-21',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3158,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-20',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3157,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-19',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3156,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-18',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3155,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-17',
    'type': 'Statutory Holiday',
    'name': 'Independence Day',
    'remark': ''
  },
  {
    'id': 3154,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-16',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3153,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-15',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3152,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-14',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3151,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-13',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3150,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-12',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3149,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-11',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3148,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-10',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3147,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-09',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3146,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-08',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3145,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-07',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3144,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-06',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3143,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-05',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3142,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-04',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3141,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-03',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3140,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-02',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3139,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-08-01',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3138,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-31',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3137,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-30',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3136,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-29',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3135,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-28',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3134,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-27',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3133,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-26',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3132,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-25',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3131,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-24',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3130,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-23',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3129,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-22',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3128,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-21',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3127,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-20',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3126,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-19',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3125,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-18',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3124,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-17',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3123,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-16',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3122,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-15',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3121,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-14',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3120,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-13',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3119,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-12',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3118,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-11',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3117,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-10',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3116,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-09',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3115,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-08',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3114,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-07',
    'type': 'Statutory Holiday',
    'name': 'Muharram',
    'remark': ''
  },
  {
    'id': 3113,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-06',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3112,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-05',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3111,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-04',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3110,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-03',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3109,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-02',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3108,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-07-01',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3107,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-30',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3106,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-29',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3105,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-28',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3104,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-27',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3103,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-26',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3102,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-25',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3101,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-24',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3100,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-23',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3099,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-22',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3098,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-21',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3097,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-20',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3096,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-19',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3095,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-18',
    'type': 'Statutory Holiday',
    'name': 'Idul Adha Holiday',
    'remark': ''
  },
  {
    'id': 3094,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-17',
    'type': 'Statutory Holiday',
    'name': 'Idul Adha',
    'remark': ''
  },
  {
    'id': 3093,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-16',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3092,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-15',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3091,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-14',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3090,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-13',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3089,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-12',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3088,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-11',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3087,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-10',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3086,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-09',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3085,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-08',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3084,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-07',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3083,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-06',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3082,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-05',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3081,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-04',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3080,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-03',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3079,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-02',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3078,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-06-01',
    'type': 'Statutory Holiday',
    'name': 'Pancasila Day',
    'remark': ''
  },
  {
    'id': 3077,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-31',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3076,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-30',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3075,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-29',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3074,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-28',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3073,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-27',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3072,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-26',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3071,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-25',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3070,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-24',
    'type': 'Statutory Holiday',
    'name': 'Waisak Day Holiday',
    'remark': ''
  },
  {
    'id': 3069,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-23',
    'type': 'Statutory Holiday',
    'name': 'Waisak Day',
    'remark': ''
  },
  {
    'id': 3068,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-22',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3067,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-21',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3066,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-20',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3065,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-19',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3064,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-18',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3063,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-17',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3062,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-16',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3061,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-15',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3060,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-14',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3059,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-13',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3058,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-12',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3057,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-11',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3056,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-10',
    'type': 'Statutory Holiday',
    'name': 'Ascension Day Holiday',
    'remark': ''
  },
  {
    'id': 3055,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-09',
    'type': 'Statutory Holiday',
    'name': 'Ascension Day',
    'remark': ''
  },
  {
    'id': 3054,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-08',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3053,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-07',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3052,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-06',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3051,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-05',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3050,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-04',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3049,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-03',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3048,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-02',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3047,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-05-01',
    'type': 'Statutory Holiday',
    'name': 'Labour Day',
    'remark': ''
  },
  {
    'id': 3046,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-30',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3045,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-29',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3044,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-28',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3043,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-27',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3042,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-26',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3041,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-25',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3040,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-24',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3039,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-23',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3038,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-22',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3037,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-21',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3036,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-20',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3035,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-19',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3034,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-18',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3033,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-17',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3032,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-16',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3031,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-15',
    'type': 'Statutory Holiday',
    'name': 'Hari Raya Puasa Holiday',
    'remark': ''
  },
  {
    'id': 3030,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-14',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3029,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-13',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3028,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-12',
    'type': 'Statutory Holiday',
    'name': 'Hari Raya Puasa Holiday',
    'remark': ''
  },
  {
    'id': 3027,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-11',
    'type': 'Statutory Holiday',
    'name': 'Hari Raya Puasa Holiday',
    'remark': ''
  },
  {
    'id': 3026,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-10',
    'type': 'Statutory Holiday',
    'name': 'Hari Raya Puasa',
    'remark': ''
  },
  {
    'id': 3025,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-09',
    'type': 'Statutory Holiday',
    'name': 'Hari Raya Puasa Holiday',
    'remark': ''
  },
  {
    'id': 3024,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-08',
    'type': 'Statutory Holiday',
    'name': 'Hari Raya Puasa Holiday',
    'remark': ''
  },
  {
    'id': 3023,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-07',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3022,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-06',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3021,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-05',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3020,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-04',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3019,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-03',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3018,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-02',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3017,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-04-01',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3016,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-31',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3015,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-30',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3014,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-29',
    'type': 'Statutory Holiday',
    'name': 'Good Friday',
    'remark': ''
  },
  {
    'id': 3013,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-28',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3012,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-27',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3011,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-26',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3010,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-25',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3009,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-24',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3008,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-23',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3007,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-22',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 3006,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-21',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 3005,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-20',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 3004,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-19',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 3003,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-18',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 3002,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-17',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3001,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-16',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 3000,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-15',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 2999,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-14',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 2998,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-13',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 2997,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-12',
    'type': 'Statutory Holiday',
    'name': 'Hari Raya Nyepi Holiday',
    'remark': ''
  },
  {
    'id': 2996,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-11',
    'type': 'Statutory Holiday',
    'name': 'Hari Raya Nyepi',
    'remark': ''
  },
  {
    'id': 2995,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-10',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 2994,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-09',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 2993,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-08',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 2992,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-07',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 2991,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-06',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 2990,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-05',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 2989,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-04',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 2988,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-03',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 2987,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-02',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 2986,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-03-01',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 2985,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-29',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 2984,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-28',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 2983,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-27',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 2982,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-26',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 2981,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-25',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 2980,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-24',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 2979,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-23',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 2978,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-22',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 2977,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-21',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 2976,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-20',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 2975,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-19',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 2974,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-18',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 2973,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-17',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 2972,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-16',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 2971,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-15',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 2970,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-14',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 2969,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-13',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 2968,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-12',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 2967,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-11',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 2966,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-10',
    'type': 'Statutory Holiday',
    'name': 'Imlek',
    'remark': ''
  },
  {
    'id': 2965,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-09',
    'type': 'Statutory Holiday',
    'name': 'Imlek Holiday',
    'remark': ''
  },
  {
    'id': 2964,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-08',
    'type': 'Statutory Holiday',
    'name': 'Isra Miraj',
    'remark': ''
  },
  {
    'id': 2963,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-07',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 2962,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-06',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 2961,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-05',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 2960,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-04',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 2959,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-03',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 2958,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-02',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 2957,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-02-01',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 2956,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-31',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 2955,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-30',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 2954,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-29',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 2953,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-28',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 2952,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-27',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 2951,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-26',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 2950,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-25',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 2949,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-24',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 2948,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-23',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 2947,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-22',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 2946,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-21',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 2945,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-20',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 2944,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-19',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 2943,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-18',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 2942,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-17',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 2941,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-16',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 2940,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-15',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 2939,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-14',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 2938,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-13',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 2937,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-12',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 2936,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-11',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 2935,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-10',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 2934,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-09',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 2933,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-08',
    'type': 'Working Days',
    'name': 'Monday',
    'remark': ''
  },
  {
    'id': 2932,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-07',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 2931,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-06',
    'type': 'Weekends',
    'name': 'Weekends',
    'remark': ''
  },
  {
    'id': 2930,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-05',
    'type': 'Working Days',
    'name': 'Friday',
    'remark': ''
  },
  {
    'id': 2929,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-04',
    'type': 'Working Days',
    'name': 'Thursday',
    'remark': ''
  },
  {
    'id': 2928,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-03',
    'type': 'Working Days',
    'name': 'Wednesday',
    'remark': ''
  },
  {
    'id': 2927,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-02',
    'type': 'Working Days',
    'name': 'Tuesday',
    'remark': ''
  },
  {
    'id': 2926,
    'country': 'Indonesia',
    'year': '2024',
    'date': '2024-01-01',
    'type': 'Statutory Holiday',
    'name': "New Year's Day",
    'remark': ''
  }
]



// WEBPACK FOOTER //
// ./src/views/gcplog/config.js